// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8dfa41e5e17c6a5b385fdb3148419d03bca5a9b7/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};